import nectarFormRequest from './nectarFormModel';

const nectarFormSubmit = () => {
	const nectarSubmitBtn = document.getElementById('nectarSubmit');

	if (nectarSubmitBtn) {
		nectarSubmitBtn.addEventListener('click', nectarValidation);
	}
};

async function nectarCallAPI(cardNumber) {
	const nectarContent = document.getElementById('nectarContent');
	const { data } = await nectarFormRequest(cardNumber);
	nectarContent.innerHTML = data;
	nectarFormSubmit();
}

function nectarValidation(e) {
	e.preventDefault();
	const validation = /^[0-9]+$/;
	const nectarInput = document.getElementById('nectarCardNumber');

	if (validation.test(nectarInput.value) && nectarInput.value.length >= 11) {
		const cardNumber = { cardNumber: `98263000${nectarInput.value}` };
		nectarCallAPI(cardNumber);
	} else {
		nectarError(nectarInput);
	}
}

function nectarError(nectarInput) {
	const nectarHelperMobile = document.getElementById('nectarHelperMobile');
	const nectarHelperDesktop = document.getElementById('nectarHelperDesktop');

	if (nectarHelperMobile && nectarHelperDesktop) {
		const nectarErrorText = nectarInput.getAttribute('data-nectar-error');

		nectarHelperMobile.classList.remove('nectar-form-submit__helper');
		nectarHelperMobile.classList.add('nectar-form-submit__error');
		nectarHelperMobile.setAttribute('data-message-type', 'error');
		nectarHelperMobile.innerHTML = nectarErrorText;

		nectarHelperDesktop.classList.remove('nectar-form-submit__helper');
		nectarHelperDesktop.classList.add('nectar-form-submit__error');
		nectarHelperDesktop.setAttribute('data-message-type', 'error');

		nectarHelperDesktop.innerHTML = nectarErrorText;
	}
}

export default nectarFormSubmit;
